import { render, staticRenderFns } from "./DialogImgsOP.vue?vue&type=template&id=6279b704&scoped=true&"
import script from "./DialogImgsOP.vue?vue&type=script&lang=js&"
export * from "./DialogImgsOP.vue?vue&type=script&lang=js&"
import style0 from "./DialogImgsOP.vue?vue&type=style&index=0&id=6279b704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6279b704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCarousel,VCarouselItem,VDialog,VIcon})
